<template>
  <div>
    <bannerHome />
    <welcome />
    <aboutUsHome />
    <servicesHome />
  </div>
</template>

<script>
import welcome from "../components/Home/welcome";
import bannerHome from "../components/Home/banner";
import aboutUsHome from "../components/Home/aboutUs";
import servicesHome from "../components/Home/services";
export default {
  name: "Home",
  components: {
    welcome,
    bannerHome,
    aboutUsHome,
    servicesHome,
  },
  created() {
    document.title = "OverLab";
  },
};
</script>
<style lang="css" scoped>

.sec {
  width: 100%;
  min-height:auto;
}

.MyContainer-fluid {
  height: auto;
  width: 100%;
}

.MyContainer {
  height: auto;
  width: 90%;
  margin: 0 5%;
}

.MyContainer-fluid .title-center {
  background: var(--secondary);
  text-align: center;
  padding: 10px;
}

.MyContainer .title-center h1 {
  color: #fff;
}
</style>
